import { toast } from "react-toastify"
import { fetchConToken, fetchConTokenFileExcel } from "../../helpers/fetch"

export const initialState = {
    id: 0,
    nombre: '',
    apellidos: '',
    tipo: 'empresa',
    nro_documento: null,
    tipo_documento: null,
    razon_social: '',
    rubro: null,
    id_pais: null, // perú
    id_departamento: null,
    id_provincia: null,
    id_distrito: null,
    email: null,
    celular: null,
    fecha_nacimiento: null,
    sitio_web: null,
    telefono: null,
    direccion: null,
    fecha_creacion: null,
    nombre_comercial: '',
    descripcion: null,
    aniversario: null,
    url_foto: null,
    estado: true,
    clasificacion: 'cliente',
    nombre_completo: null,
    ultima_actualizacion: null,
    id_banco: null,
    banco_tipo_cuenta: null,
    banco_nro_cuenta: null,
    banco_nro_cci: null
}

export const Ubi = async () => {

    let countries = []
    let deptos = []
    let prov = []
    let distritos = []

    try {

        const resp = await fetchConToken('ubis')
        const result = await resp.json()
        console.log('--result--', result)

        if (result.ok) {
            return {
                countries: result.data.paises,
                deptos: result.data.deptos,
                prov: result.data.prov,
                distritos: result.data.distritos
            }
        } else {
            toast.error('Lo sentimos, ocurrió un error')
        }

        return {
            countries,
            deptos,
            prov,
            distritos
        }

    } catch (error) {
        console.log('---error--', error)
        toast.error(error)
    }

}

export const Contacts = {

    getOne: async (id) => {
        try {

            const resp = await fetchConToken(`contacts/${id}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    getAll: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`contacts/?${params}`)
            const body = await resp.json()
            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getRelacionados: async (idContacto) => {
        try {

            const resp = await fetchConToken(`contacts/relacionados/${idContacto}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || []
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    save: async (data) => {
        try {

            const resp = await fetchConToken('contacts/save', data, "POST")
            const body = await resp.json();

            if (body.ok) {
                toast.success('datos guardados')
                return body.data.id
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return 0
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    update: async (data) => {
        try {

            const resp = await fetchConToken(`contacts/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success('datos actualizados')
                return body.data
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    unionRela: async (rela, personas) => {
        try {

            let final = []

            for (let x = 0; x < rela.length; x++) {
                final.push({
                    id: rela[x].id_relacionado,
                    nombre: rela[x].nombre,
                    email: rela[x].email
                })
            }

            final.push({
                id: -1,
                nombre: ''
            })

            for (let x = 0; x < personas.length; x++) {
                if (!final.find(a => parseInt(a.id) === parseInt(personas[x].id))) {
                    final.push({
                        id: personas[x].id,
                        nombre: personas[x].nombre,
                        email: personas[x].email
                    })
                }
            }

            return final

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    deleteRelacion: async (id) => {
        try {

            try {

                const resp = await fetchConToken(`relation/delete/${id}`, { id }, "POST")
                const body = await resp.json()

                if (body.ok) {
                    toast.success('Relación quitada!')
                    return true
                } else {
                    toast.error('Lo sentimos, ocurrió un error')
                    return false
                }

            } catch (error) {
                console.log(error)
                toast.error(error)
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
            return false
        }
    },

    getExport: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const fileName = `contactos_${new Date()}_`
            const resp = await fetchConTokenFileExcel(`contacts/export/excel/?${params}`, {}, 'GET', fileName)
            const body = await resp.json()
            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }

}